import { mockConsumerAbi } from '@/abi'
import { useReadContract } from 'wagmi'

export const useRequestLastId = ({ consumerAddress }) => {
  const { data: lastRequestId, refetch } = useReadContract({
    address: consumerAddress,
    abi: mockConsumerAbi,
    functionName: 'currentId',
  })

  return {
    data: lastRequestId ? Number(lastRequestId) - 1 : null,
    refetch,
  }
}
